var map = {
	"./bg-music.png": "e1f6",
	"./bg1.png": "b49a",
	"./bg10.png": "33e9",
	"./bg11.png": "c543",
	"./bg12.png": "197c",
	"./bg13.png": "8d63",
	"./bg14.png": "1054",
	"./bg15.png": "f340",
	"./bg16.png": "1b3c",
	"./bg17.png": "37ad",
	"./bg18.png": "bc19",
	"./bg19.png": "126a",
	"./bg2.png": "dc68",
	"./bg20.png": "c859",
	"./bg21.png": "6762",
	"./bg22.png": "7fab",
	"./bg23.png": "d6a3",
	"./bg24.png": "9a5f",
	"./bg25.png": "71d6",
	"./bg26.png": "9aab",
	"./bg27.png": "725f",
	"./bg28.png": "897d",
	"./bg29.png": "0d8a",
	"./bg3.png": "49fc",
	"./bg30.png": "6c17",
	"./bg31.png": "ec38",
	"./bg32.png": "8b36",
	"./bg33.png": "4790",
	"./bg34.png": "2d23",
	"./bg35.png": "9516",
	"./bg36.png": "2bb9",
	"./bg37.png": "21d4",
	"./bg38.png": "6847",
	"./bg39.png": "37c6",
	"./bg4.png": "35d2",
	"./bg40.png": "414f",
	"./bg41.png": "0d0c",
	"./bg42.png": "500a",
	"./bg43.png": "f24a",
	"./bg44.png": "7ad6",
	"./bg45.png": "ee7d",
	"./bg46.png": "af9b",
	"./bg47.png": "313b",
	"./bg48.png": "eacb",
	"./bg49.png": "46ea",
	"./bg5.png": "229e",
	"./bg50.png": "5a67",
	"./bg51.png": "3640",
	"./bg52.png": "8682",
	"./bg53.png": "ffa4",
	"./bg54.png": "9b99",
	"./bg55.png": "c0fe",
	"./bg6.png": "0890",
	"./bg7.png": "49cc",
	"./bg8.png": "2712",
	"./bg9.png": "b663"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "106a";